import styled from 'styled-components';

const Heading = styled.div`
  font-size: 2.6rem;
  font-weight: 600;
  margin-bottom: 3rem;
`;

export default Heading;
